import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";

export const LoadingWithPhrases = ({
  phrases,
  description,
  width,
  height,
  titleClassName,
  descriptionClassName,
}: {
  phrases: string[];
  description?: string;
  width?: string;
  height?: string;
  titleClassName?: string;
  descriptionClassName?: string;
}) => {
  const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentPhraseIndex(prev => (prev + 1) % phrases.length);
    }, 2500);

    return () => clearInterval(interval);
  }, [phrases]);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="flex h-full w-full flex-col items-center justify-center gap-2"
    >
      <img
        src="/wrangler.gif"
        alt="Loading"
        className={`${height ?? "h-[230px]"} ${width ?? "w-[230px]"}`}
      />
      <AnimatePresence mode="wait">
        <motion.span
          key={currentPhraseIndex}
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -20, opacity: 0 }}
          transition={{ duration: 0.3, ease: "easeInOut" }}
          className={`text-md block text-gray-500 ${titleClassName ?? ""}`}
        >
          {phrases[currentPhraseIndex]}
        </motion.span>
      </AnimatePresence>
      {description && (
        <motion.span
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
          className={`max-w-[360px] text-center text-sm text-gray-500 ${
            descriptionClassName ?? ""
          }`}
        >
          {description}
        </motion.span>
      )}
    </motion.div>
  );
};
